/**
 * app router
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: '/agreement-docs',
  routes: [
    {
      path: '/guoguozhiyou/privacy',
      component: () => import('@/view/guoguozhiyou/privacy.vue'),
      meta: {
        title: '果果智游隐私政策'
      }
    },
    {
      path: '/guoguozhiyou/terms',
      component: () => import('@/view/guoguozhiyou/terms.vue'),
      meta: {
        title: '果果智游服务协议'
      }
    },
    {
      path: '/sftoys/privacy',
      component: () => import('@/view/sftoys/privacy.vue'),
      meta: {
        title: 'SFToys隐私政策'
      }
    },
    {
      path: '/sftoys/terms',
      component: () => import('@/view/sftoys/terms.vue'),
      meta: {
        title: 'SFToys服务协议'
      }
    },
    {
      path: '/history-list/aigc',
      component: () => import('@/view/history/AIGCList.vue'),
      meta: {
        title: '历史法律文件'
      }
    },
    {
      path: '/history-list/peiyin',
      component: () => import('@/view/history/peiyinList.vue'),
      meta: {
        title: '历史法律文件'
      }
    },
    {
      path: '/history-list/course-agreement-2023-12',
      component: () => import('@/view/history/classWord.vue'),
      meta: {
        title: '配音课程服务协议-商单'
      }
    },
    {
      path: '/history-list/course-agreement-v4',
      component: () => import('@/view/history/audio4.vue'),
      meta: {
        title: '配音课程服务协议-4.0版本'
      }
    },
    {
      path: '/history-list/authority',
      component: () => import('@/view/history/authority.vue'),
      meta: {
        title: '爱奇艺遍知应用权限申请及使用说明'
      }
    },
    {
      path: '/history-list/course-agreement-v4-2024-6',
      component: () => import('@/view/history/audio6.vue'),
      meta: {
        title: '配音课程服务协议-4.0版本'
      }
    }
    // {
    //   path: '/historyList/seven',
    //   component: () => import('@/view/history/seven.vue'),
    //   meta: {
    //     title: '爱奇艺遍知隐私政策'
    //   }
    // },
    // {
    //   path: '/historyList/two',
    //   component: () => import('@/view/history/two.vue'),
    //   meta: {
    //     title: '爱奇艺遍知隐私政策'
    //   }
    // },
    // {
    //   path: '/historyList/three',
    //   component: () => import('@/view/history/three.vue'),
    //   meta: {
    //     title: '爱奇艺遍知隐私政策'
    //   }
    // },
    // {
    //   path: '/historyList/three-31',
    //   component: () => import('@/view/history/three-31.vue'),
    //   meta: {
    //     title: '爱奇艺遍知隐私政策'
    //   }
    // }
  ]
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  // if (to.meta.title) {
  document.title = to.meta.title
  // } else {
  //   document.title = '爱奇艺知识'
  // }
  next()
})
export default router
